module.exports = __webpack_public_path__ + "img/UTGOBL-4.81f059c7.jpg";